import '../RadioGroup/radioGroup.scss';

import CssBaseline from '@mui/material/CssBaseline';
import uniqueId from 'lodash/uniqueId';
import { ReactNode } from 'react';

import { Radio } from '../Radio/Radio';

type RadioGroupLoadingProps = {
  variant?: 'stacked' | 'stacked-compact' | 'inline';
  labelPlacement?: 'beside' | 'below';
  loadingCount: number;
};

export const RadioGroupLoading = ({
  variant = 'stacked',
  labelPlacement = 'beside',
  loadingCount,
}: RadioGroupLoadingProps): ReactNode => {
  return (
    <CssBaseline>
      <div className={`radio-group ${variant}`} role="radiogroup">
        {[...Array(loadingCount)].map(
          (): ReactNode => (
            <Radio
              key={uniqueId('loading-')}
              label=""
              labelPlacement={labelPlacement}
              loading
            />
          ),
        )}
      </div>
    </CssBaseline>
  );
};
